import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface DetailFact {
  key: string;
  label: string;
  value: ReactNode;
}

/**
 * Key facts of a catalog detail page as one wrapping row. Items size to their
 * content and wrap to a new line; missing facts are simply omitted by the caller,
 * so no empty cells or fixed columns break on long values.
 */
export function DetailFactsRow({ facts, className }: { facts: DetailFact[]; className?: string }) {
  if (facts.length === 0) return null;

  return (
    <dl
      className={cn(
        "flex flex-wrap gap-x-8 gap-y-3 border-y border-border/70 py-3.5 sm:gap-x-10",
        className,
      )}
    >
      {facts.map((fact) => (
        <div key={fact.key} className="flex min-w-0 max-w-full flex-col gap-1">
          <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-muted-foreground">
            {fact.label}
          </dt>
          <dd className="min-w-0 break-words font-bold tabular-nums">{fact.value}</dd>
        </div>
      ))}
    </dl>
  );
}
